import { useNavigate } from "react-router-dom";
import TestFormInterface from "../../../Interfaces/TestFormInterface";
import StyledButton from "../../UI/StyledButton";
import StyledInput from "../../UI/StyledInput";
import ReactLoading from "react-loading";
import { useState } from "react";
import { directus } from "../../../Api/FetchDirectus";
import { login, readItems } from "@directus/sdk";
import StyledPassword from "../../UI/StyledPassword";

const Login = ({ close, reg }: TestFormInterface) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [emailStatus, setEmailStatus] = useState(false);
  const [passwordStatus, setPasswordStatus] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function onClose() {
    close(false);
  }

  function onChange(e: any, type: string) {
    if (type === "email") {
      setEmail(e.target.value);
    }

    if (type === "password") {
      setPassword(e.target.value);
    }
  }

  async function goTest() {
    setLoader(true);
    if (email.trim() === "" || !validateEmail(email)) {
      setEmailStatus(true);
    } else {
      setEmailStatus(false);
    }

    if (password.trim() === "" || password.length < 8) {
      setPasswordStatus(true);
    } else {
      setPasswordStatus(false);
    }

    if (validateEmail(email) && password.length >= 8) {
      let result;
      try {
        result = await directus.request(login(email, password));

        localStorage.setItem("email", email);
        // const lastList = await directus.request(
        //   readItems("Course_History", { limit: -1 })
        // );

        const lastList = async () => {
          try {
            return await directus.request(
              readItems(`Course_History`, {
                limit: 1,
                sort: "-id",
                filter: { email: { _eq: email } },
              })
            );
          } catch (error: any) {
            sessionStorage.removeItem("token");
            navigate("/");
            return [];
          }
        };

        let rawLastList = [...(await lastList())];

        rawLastList.sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );

        if (rawLastList.length > 0) {
          let last = rawLastList[rawLastList.length - 1] as {
            email: string;
            url: string;
            course: string;
            module: string;
            topic: string;
            scales: string;
            my_courses: string;
            active_course: string;
            form: string;
            completed: string;
            certificat_completed: string;
            certificat_link: string;
          };

          localStorage.setItem("scales", JSON.stringify(last));

          last.scales !== "" && localStorage.setItem("scales", last.scales);
          last.my_courses !== "" &&
            localStorage.setItem("my_courses", last.my_courses);
          last.active_course !== "" &&
            localStorage.setItem("active_course", last.active_course);
          last.course !== "" && localStorage.setItem("courseInfo", last.course);
          last.module !== "" &&
            localStorage.setItem("module_files", last.module);
          last.topic !== "" && localStorage.setItem("topic_files", last.topic);
          last.completed !== "" &&
            localStorage.setItem("completed", last.completed);
            last.certificat_completed !== "" &&
            localStorage.setItem(
              "certificat_completed",
              last.certificat_completed
            );
            last.certificat_link !== "" &&
            localStorage.setItem(
              "certificat_link",
              last.certificat_link
            );

          const form = JSON.parse(last.form);

          localStorage.setItem("age", form.age);
          localStorage.setItem("gender", form.gender);
          localStorage.setItem("activity", form.activity);
          localStorage.setItem("position", form.position);
          if (!last.course) {
            navigate("/");
          } else {
            if (!last.scales || last.scales === "") {
              navigate("/Modules");
            } else {
              navigate(last.url);
            }
          }
        }

        setLoader(false);
        close(false);
      } catch (error: any) {
        setLoader(false);

        if (error?.response?.status === 401) {
          setErrorStatus(true);
          setErrorText("Электронная почта или пароль введены неверно");
        } else {
          setErrorStatus(true);
          setErrorText("Возникла ошибка");
        }
        sessionStorage.removeItem("token");
        return;
      }

      result.access_token &&
        sessionStorage.setItem("token", result.access_token);
    }
    setLoader(false);
  }

  function onRegistration() {
    reg(true);
    close(false);
  }

  return (
    <div className="popUp">
      <div className="popTestForm">
        <div className="closeFormBox">
          <div className="closeFormButton" onClick={onClose}>
            <span></span>
            <span></span>
          </div>
        </div>
        <h2>Авторизация</h2>
        {errorStatus ? <div className="errorText">{errorText}</div> : null}
        {emailStatus && !validateEmail(email) ? (
          <div className="errorText">Почта введена неверно</div>
        ) : null}
        <StyledInput
          text="Электронная почта"
          placeholder="Укажите вашу электронную почту"
          className={emailStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "email")}
        />

        {passwordStatus && password.length < 8 ? (
          <div className="errorText">
            Пароль должен быть не меньше 8 символов
          </div>
        ) : null}
        <StyledPassword
          text="Пароль"
          placeholder="Укажите пароль"
          className={passwordStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "password")}
        />

        <div className="testFormStartBox">
          {loader ? (
            <ReactLoading
              type="spinningBubbles"
              color="black"
              height={"50px"}
              width={"50px"}
            />
          ) : (
            <StyledButton
              onClick={() => goTest()}
              className="blueButton testFormButton"
              text="ВОЙТИ"
            />
          )}
          <div className="switchLogReg" onClick={onRegistration}>
            Зарегистрироваться
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
